import { Component } from "@angular/core";
interface IListData {
  title: string;
  id?: number;
  loading?: boolean;
}

@Component({
  selector: "gh-example-list-component",
  templateUrl: "./example-list.component.html",
  styleUrls: ["./example-list.component.less"],
})
export class ExampleListComponent {
  public simpleData = [
    "Racing car sprays burning fuel into crowd.",
    "Japanese princess to wed commoner.",
    "Australian walks 100km after outback crash.",
    "Man charged over missing wedding girl.",
    "Los Angeles battles huge wildfires.",
  ];
  public loading = false;
  public data: IListData[] = [];
  public moreData: IListData[] = [{ title: `Title 1`, id: 1 }];
  public dataCard: IListData[] = [{ title: "Card 1" }, { title: "Card 2" }, { title: "Card 3" }, { title: "Card 4" }, { title: "Card 5" }, { title: "Card 6" }];

  public setData(data: IListData[], i = 1, end = 4): void {
    for (; i < end; i++) {
      const tmp = {
        title: `Title ${i}`,
        id: i,
        loading: true,
      };
      data.push(tmp);
      this.updateLoadingAfterSecond(tmp);
    }
  }

  public updateLoadingAfterSecond(obj: IListData): void {
    setTimeout(() => {
      obj.loading = false;
    }, Math.floor(Math.random() * (5000 - 1000 + 1) + 1000));
  }

  public change(): void {
    this.loading = true;
    if (this.data.length > 0) {
      setTimeout(() => {
        this.data = [];
        this.loading = false;
      }, 1000);
    } else {
      setTimeout(() => {
        this.setData(this.data);
        this.loading = false;
      }, 1000);
    }
  }

  public onLoadMore(): void {
    this.setData(this.moreData, this.moreData.length || 1, this.moreData.length + 3);
  }

  public clickItem(item: string): void {
    // eslint-disable-next-line no-console
    console.log("Item clicked: ", item);
  }
}
